import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import DropdownInput from "./DropdownInput";
import { LANG_LOCAL_STORAGE } from "config/keywords";
import { SupportedLang } from "config/constants";
import type { DropdownInputOption } from "types/DropdownInputOption";
import EarthIcon from "assets/icons/EarthIcon";

const OPTIONS: DropdownInputOption[] = [
  {
    label: "日本語",
    value: "ja",
  },
  {
    label: "English",
    value: "en",
  },
];

interface LanguageDropdownProps {
  variant?: "default" | "header";
}

const LanguageDropdown = ({
  variant = "default",
}: LanguageDropdownProps) => {
  const [lang, setLang] = useState("");
  useEffect(() => {
    const currentLang = localStorage.getItem(LANG_LOCAL_STORAGE);
    if (!currentLang) {
      localStorage.setItem(LANG_LOCAL_STORAGE, SupportedLang.ja);
      setLang(SupportedLang.ja);
      return;
    }
    setLang(currentLang);
  }, []);

  const { i18n } = useTranslation();
  const changeLanaguage = (lang: string) => {
    setLang(lang);
    localStorage.setItem(LANG_LOCAL_STORAGE, lang);
    i18n.changeLanguage(lang);
  };

  return (
    <div className={variant === "header" ? "w-auto" : "w-full"}>
      <DropdownInput
        placeholder={""}
        options={OPTIONS}
        value={lang}
        variant={variant}
        prefix={
          variant === "header" ? (
            <EarthIcon width={16} height={16} color={"#000000"} />
          ) : undefined
        }
        onChange={changeLanaguage}
      />
    </div>
  );
};

export default LanguageDropdown;
